import { render } from "./PostListAuthor.vue?vue&type=template&id=7bfd220a"
import script from "./PostListAuthor.vue?vue&type=script&lang=js"
export * from "./PostListAuthor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__